<template>
    <v-card :class="['dialog-card', cardClass]">
        <v-card-title :class="['d-flex align-center justify-space-between', titleClass]">
            <slot name="title">
                <div class="dialog-layout__header-text">
                    <div class="text-h6 dialog-layout__title">{{ title }}</div>
                    <div v-if="subtitle" class="text-caption text-medium-emphasis dialog-layout__subtitle">
                        {{ subtitle }}
                    </div>
                </div>
            </slot>

            <div class="d-flex align-center gap-2">
                <slot name="title-actions" />
                <v-btn v-if="!hideClose" :disabled="closeDisabled" icon="mdi-close" variant="text" @click="$emit('close')" />
            </div>
        </v-card-title>

        <v-divider class="gradient-divider--dim" />

        <v-card-text :class="['dialog-layout__body', bodyClass]">
            <slot />
        </v-card-text>

        <template v-if="hasActions">
            <v-divider class="gradient-divider" />
            <v-card-actions :class="['dialog-layout__actions', actionsClass]">
                <slot name="actions" />
            </v-card-actions>
        </template>
    </v-card>
</template>

<script lang="ts" setup>
    import { computed, useSlots, withDefaults } from 'vue';

    withDefaults(
        defineProps<{
            title?: string;
            subtitle?: string;
            hideClose?: boolean;
            closeDisabled?: boolean;
            titleClass?: string;
            bodyClass?: string;
            actionsClass?: string;
            cardClass?: string;
        }>(),
        {
            title: '',
            subtitle: '',
            hideClose: false,
            closeDisabled: false,
            titleClass: '',
            bodyClass: '',
            actionsClass: 'justify-end',
            cardClass: '',
        },
    );

    defineEmits<{
        (e: 'close'): void;
    }>();

    const slots = useSlots();
    const hasActions = computed(() => !!slots.actions);
</script>

<style scoped>
    /* Keep header and footer fixed while body scrolls */
    .dialog-card {
        display: flex;
        flex-direction: column;
        max-height: 85vh;
        min-height: 0;
        overflow: hidden;
    }

    .dialog-layout__header-text {
        min-width: 0;
    }

    .dialog-layout__subtitle {
        white-space: normal;
        overflow-wrap: anywhere;
    }

    .dialog-layout__body {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .dialog-layout__actions {
        flex-shrink: 0;
    }
</style>
